'use client';

import { TWA_SUBSCRIPTION_NOTICE } from '@/lib/twa-detection';

/**
 * Text-only billing notice shown inside the Android app (TWA) wherever a
 * purchase surface would otherwise appear. Google Play payments policy forbids
 * any tappable path to payment inside the app, so this renders a heading plus
 * a plain-text instruction — NO link, NO button, NO price.
 */
export default function TwaSubscriptionNotice({
  heading = 'Subscriptions',
  className = '',
}: {
  heading?: string;
  className?: string;
}) {
  return (
    <div className={`min-h-screen bg-slate-50 flex items-center justify-center px-4 py-16 ${className}`}>
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">{heading}</h1>
        <p className="mt-4 text-sm leading-6 text-slate-600">{TWA_SUBSCRIPTION_NOTICE}</p>
      </div>
    </div>
  );
}
